export default "__VITE_ASSET__c0451795__"